/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable import/no-extraneous-dependencies */

import { useState, useEffect, useRef, useContext } from "react";
import {
  Badge,
  Button,
  Combobox,
  Input,
  Popover,
  PopoverContent,
  PopoverTrigger,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@repo/ui";
import { CircleX, RefreshCcw, SlidersHorizontal } from "lucide-react";
import { FaFileExcel } from "react-icons/fa";
import { Loader as KendoLoader } from "@progress/kendo-react-indicators";
import {
  useLookupActivityTypes,
  useLookupAllAssignmentGroups,
  useLookupCashCenters,
  useLookupCustomers,
  useLookupMachinesServicePoints,
} from "services/lookups";
import { defaultFilters, FiltersContext } from "store/filters-context";

const PERIODS = [
  {
    id: "All",
    text: "All",
  },
  { id: "Today", text: "Today" },
  { id: "Yesterday", text: "Yesterday" },

  {
    id: "This Week",
    text: "This Week",
  },
  {
    id: "Last Week",
    text: "Last Week",
  },
  {
    id: "This Month",
    text: "This Month",
  },
];
const STATUS_LIST = [
  { id: "All", text: "All" },
  { id: "Draft", text: "Draft" },
  { id: "Open", text: "Open" },
  { id: "Assigned", text: "Assigned" },
  { id: "In Progress", text: "In Progress" },
  { id: "On Hold", text: "On Hold" },
  { id: "Resolved", text: "Resolved" },
  { id: "Awaiting Customer Approval", text: "Awaiting Customer Approval" },
  { id: "Closed", text: "Closed" },
  { id: "Rejected", text: "Rejected" },
  { id: "Cancelled", text: "Cancelled" },
  { id: "Awaiting Re-Opening", text: "Awaiting Re-Opening" },
];
export default function FilterBarV2({
  hideAsset,
  hideStatus,
  exportExcel,
  onExcelExport,
  exportingExcel,
  onRefresh,
}) {
  const { filters, setFilters } = useContext(FiltersContext);
  const [selectedCashCenter, setSelectedCashCenter] = useState(
    filters?.cashCenterId?.value || ""
  );
  const [selectedCustomer, setSelectedCustomer] = useState(
    filters?.customerId?.value || ""
  );
  const [selectedLocation, setSelectedLocation] = useState(
    filters?.assetId?.value || ""
  );
  const [selectedStatus, setSelectedStatus] = useState(
    filters?.status?.value || "All"
  );
  const [selectedDate, setSelectedDate] = useState(
    filters?.period?.value || "All"
  );
  const [selectedActivityType, setSelectedActivityType] = useState(
    filters?.activityType?.value || ""
  );
  const [selectedAssignment, setSelectedAssignment] = useState(
    filters?.assignmentGroup?.value || ""
  );
  const [assignmentGroupList, setAssignmentGroupList] = useState("");
  const [filter, setFilter] = useState(filters?.searchCriteria?.value || "");
  const filterTimeout = useRef(null);

  const { mutate: getCashCenters, data: cashCentersList } =
    useLookupCashCenters();
  const { mutate: getCustomers, data: customersList } = useLookupCustomers();

  const {
    mutate: getLocations,
    data: locationsList,
    reset: resetLocations,
  } = useLookupMachinesServicePoints();

  const { mutate: getActivityTypes, data: activityTypesRes } =
    useLookupActivityTypes();
  const {
    mutate: getAssignmentGroups,
    data: assignmentGroupsRes,
    reset: resetAssignmentGroups,
  } = useLookupAllAssignmentGroups();

  useEffect(() => {
    getCashCenters();
    getCustomers();
    getActivityTypes();
    getAssignmentGroups();

    if (filters?.customerId?.value) {
      getLocations(filters?.customerId?.value);
    }
  }, []);

  useEffect(() => {
    if (!filters?.cashCenterId && selectedCashCenter) {
      handleClearFilter("cashCenterId");
    }
    if (!filters?.customerId && selectedCustomer) {
      handleClearFilter("customerId");
    }
    if (!filters?.assetId && selectedLocation) {
      handleClearFilter("assetId");
    }
    if (filters?.period?.value === "All" && selectedDate !== "All") {
      handleClearFilter("period");
    }
    if (filters?.status?.value === "All" && selectedStatus !== "All") {
      handleClearFilter("status");
    }
    if (!filters?.activityType && selectedActivityType) {
      handleClearFilter("activityType");
    }
    if (!filters?.assignmentGroup && selectedAssignment) {
      handleClearFilter("assignmentGroup");
    }
    if (!filters?.searchCriteria && filter) {
      handleClearFilter("searchCriteria");
    }
  }, [filters]);
  useEffect(() => {
    if (assignmentGroupsRes) {
      if (assignmentGroupsRes) {
        setAssignmentGroupList(
          (assignmentGroupsRes?.data || [])
            .filter((elm) => {
              if (
                !["Call Center", "Administrator", "customerId"].includes(
                  elm.name
                )
              ) {
                return true;
              }
              return false;
            })
            .map((elm) => ({ label: elm.name, value: elm.name }))
        );
        resetAssignmentGroups();
      }
    }
  }, [assignmentGroupsRes]);
  useEffect(() => {
    if (filter !== null) {
      filterTimeout.current = setTimeout(() => {
        handleAddFilter("searchCriteria", filter, filter, "Search");
        clearTimeout(filterTimeout.current);
        filterTimeout.current = null;
      }, 1000);
    }
    return () => {
      if (filterTimeout.current) {
        clearTimeout(filterTimeout.current);
        filterTimeout.current = null;
      }
    };
  }, [filter]);

  const handleClearFilter = (key) => {
    const updatedFilter = { ...filters };
    if (defaultFilters[key]) {
      updatedFilter[key] = { ...defaultFilters[key] };
    } else {
      delete updatedFilter[key];
    }
    if (key === "cashCenterId") {
      setSelectedCashCenter("");
    } else if (key === "customerId") {
      setSelectedCustomer("");
      setSelectedLocation("");
      delete updatedFilter.asset;
    } else if (key === "assetId") {
      setSelectedLocation("");
    } else if (key === "activityType") {
      setSelectedActivityType("");
    } else if (key === "assignmentGroup") {
      setSelectedAssignment("");
    } else if (key === "status") {
      setSelectedStatus("All");
    } else if (key === "period") {
      setSelectedDate("All");
    } else if (key === "searchCriteria") {
      setFilter("");
    }

    setFilters({ ...updatedFilter });
  };
  const handleAddFilter = (key, label, value, name) => {
    if (value === "") {
      handleClearFilter(key);
      return;
    }
    const updatedFilter = { ...filters };
    updatedFilter[key] = {
      key,
      value,
      label,
      description: `${name}: ${label}`,
    };

    setFilters({ ...updatedFilter });
  };
  const clearAllFilters = () => {
    setFilters({
      ...defaultFilters,
    });
    setSelectedCashCenter("");
    setSelectedCustomer("");
    setSelectedDate("All");
    setSelectedLocation("");
    setFilter("");
    setSelectedActivityType("");
    setSelectedStatus("All");
    setSelectedAssignment("");
  };

  return (
    <>
      <div className="flex mb-3 gap-1">
        <Popover>
          <PopoverTrigger asChild>
            <Button variant="secondary" className="w-max" title="Apply Filters">
              <SlidersHorizontal />
            </Button>
          </PopoverTrigger>
          <PopoverContent align="start" className="w-[540px]">
            <h6 className="font-semibold text-lg">Apply Filters</h6>
            <div className="grid grid-cols-2 gap-2 mt-3">
              <Combobox
                placeholder="Select Cash Center"
                data={[
                  { label: "Select Cash Center", value: "" },
                  ...((cashCentersList?.data || []).map((elm) => ({
                    label: elm.name,
                    value: elm.cashCenterId,
                  })) || []),
                ]}
                value={selectedCashCenter}
                setValue={(value) => {
                  setSelectedCashCenter(value);
                  let name = "";
                  if (value !== "") {
                    name = cashCentersList?.data.filter(
                      (elm) => elm.cashCenterId === value
                    )[0].name;
                  }
                  handleAddFilter("cashCenterId", name, value, "Cash Center");
                }}
              />
              <Combobox
                placeholder="Select Customer"
                data={[
                  { label: "Select Customer", value: "" },
                  ...((customersList?.data || []).map((elm) => ({
                    label: elm.name,
                    value: elm.customerId,
                  })) || []),
                ]}
                value={selectedCustomer}
                setValue={(value) => {
                  setSelectedCustomer(value);
                  let name = "";
                  if (value !== "") {
                    name = customersList?.data.filter(
                      (elm) => elm.customerId === value
                    )[0].name;
                  }
                  handleAddFilter("customerId", name, value, "Customer");
                  setSelectedLocation("");
                  if (value) {
                    getLocations(value);
                  } else {
                    resetLocations();
                  }
                }}
              />
              {hideAsset ? (
                <></>
              ) : (
                <Combobox
                  placeholder="Select Asset"
                  data={[
                    { label: "Select Asset", value: "" },
                    ...(locationsList?.data.map((elm) => ({
                      label: elm.locationId,
                      value: elm.servicePointId,
                    })) || []),
                  ]}
                  value={selectedLocation}
                  setValue={(value) => {
                    let name = "";
                    if (value !== "") {
                      name = locationsList?.data.filter(
                        (elm) => elm.servicePointId === value
                      )[0].locationId;
                    }
                    handleAddFilter("assetId", name, value, "Asset Id");
                    setSelectedLocation(value);
                  }}
                />
              )}

              <Combobox
                placeholder="Select Activity Type"
                data={[
                  { label: "Select Activity Type", value: "" },
                  ...(activityTypesRes?.data.map((elm) => ({
                    label: elm.description,
                    value: elm.description,
                  })) || []),
                ]}
                value={selectedActivityType}
                setValue={(value) => {
                  handleAddFilter(
                    "activityType",
                    value,
                    value,
                    "Activity Type"
                  );
                  setSelectedActivityType(value);
                }}
              />
              <Combobox
                placeholder="Select Assignment Group"
                data={[
                  { label: "Select Assignment Group", value: "" },
                  ...assignmentGroupList,
                ]}
                value={selectedAssignment}
                setValue={(value) => {
                  handleAddFilter(
                    "assignmentGroup",
                    value,
                    value,
                    "Assignment Group"
                  );
                  setSelectedAssignment(value);
                }}
              />
              {hideStatus ? (
                <></>
              ) : (
                <Select
                  side="bottom"
                  onValueChange={(e) => {
                    setSelectedStatus(e);
                    handleAddFilter("status", e, e, "Status");
                  }}
                  // defaultValue={field.value}
                  value={selectedStatus}
                >
                  <SelectTrigger>
                    <SelectValue placeholder="Select Status" />
                  </SelectTrigger>
                  <SelectContent>
                    {STATUS_LIST.map((elm, index) => (
                      <SelectItem key={index} value={elm.id}>
                        {elm.text}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              )}

              {/* <Combobox
                placeholder="Select Pending Reason"
                value={JSON.stringify(filters?.pendingReason) || ""}
                data={reasons?.map((item: any) => ({
                  value: JSON.stringify({
                    name: item.description,
                    id: item.description,
                  }),
                  label: item.description,
                }))}
                setValue={(val: string) => {
                  handleChangeFilter(val, "pendingReason");
                }}
              /> */}
            </div>
          </PopoverContent>
        </Popover>

        <div className="min-w-[15%] ">
          <Select
            onValueChange={(e) => {
              setSelectedDate(e);
              handleAddFilter("period", e, e, "Period");
            }}
            // defaultValue={field.value}
            value={selectedDate}
          >
            <SelectTrigger>
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              {PERIODS.map((elm, index) => (
                <SelectItem key={index} value={elm.id}>
                  {elm.text}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          {/* <DatePicker
            selectedDate={selectedDate}
            onSelectDate={(e) => {
              setSelectedDate(e);
              handleAddFilter("period", format(e, "PPP"), "period");
            }}
          /> */}
        </div>
        <div className="w-full">
          <Input
            value={filter}
            placeholder="Search: Case No, Status, Activity Type, Category, Sub Category, Bank Reference No, Assignment Group"
            title="Search: Case No, Status, Activity Type, Category, Sub Category, Bank Reference Number, Assignment Group"
            onChange={(e) => {
              setFilter(e.target.value);
            }}
          />
        </div>

        {exportExcel ? (
          <Button
            variant="secondary"
            style={
              {
                // color: "hsl(var(--secondary))",
                // borderColor: "hsl(var(--secondary))",
              }
            }
            disabled={exportingExcel}
            onClick={() => {
              if (onExcelExport) {
                onExcelExport();
              }
            }}
          >
            {exportingExcel ? <KendoLoader themeColor="light" /> : <></>}
            <FaFileExcel style={{ marginRight: "8px" }} />
            Export
          </Button>
        ) : (
          <></>
        )}
        <Button
          variant="secondary"
          onClick={() => {
            if (onRefresh) onRefresh();
          }}
          title="Refresh List"
        >
          <RefreshCcw style={{ marginRight: "0px", width: "16px" }} />
        </Button>
        {/* {type === "open" ? (
          <>
            <Button
              variant="secondary"
              className="flex-1 flex flex-row justify-end gap-0"
              style={{ padding: 0 }}
            >
              <Link to={PATHS.bulkOperation}>
                <Button variant="secondary" className="flex flex-row gap-2">
                  <Tickets /> Bulk Operations
                </Button>
              </Link>
            </Button>
            <Button
              variant="secondary"
              className="flex-1 flex flex-row justify-end gap-0"
              style={{ padding: 0 }}
            >
              <Link to={PATHS.createTicket}>
                <Button variant="secondary" className="flex flex-row gap-2">
                  
                  <CirclePlus /> Create Ticket
                </Button>
              </Link>
              <DropdownMenu>
                <DropdownMenuTrigger>
                  <Button
                    variant="secondary"
                    style={{
                      borderLeft: "2px solid white",
                      borderTopLeftRadius: 0,
                      borderBottomLeftRadius: 0,
                    }}
                  >
                    <FaAngleDown />
                  </Button>
                </DropdownMenuTrigger>
                <DropdownMenuContent align="end">
                  <DropdownMenuItem>
                    <Link to={PATHS.createFacilityTickets}>
                      Facility Request
                    </Link>
                  </DropdownMenuItem>
                  <DropdownMenuItem>
                    <Link to={PATHS.createCustomerComplaint}>
                      Customer Complaint
                    </Link>
                  </DropdownMenuItem>
                  <DropdownMenuItem>
                    <Link to={PATHS.createRemoteSupportRequest}>
                      Remote Support
                    </Link>
                  </DropdownMenuItem>
                  <DropdownMenuItem>
                    <Link to={PATHS.createCustomerService}>
                      Customer Service
                    </Link>
                  </DropdownMenuItem>
                  <DropdownMenuItem>
                    <Link to={PATHS.createEtisalatThirdParty}>
                      Etisalat Third Party
                    </Link>
                  </DropdownMenuItem>
                </DropdownMenuContent>
              </DropdownMenu>
            </Button>
          </>
        ) : (
          <></>
        )} */}
      </div>
      <div className="flex mb-3 gap-2 flex-wrap items-end">
        {Object.keys(filters).map((elm) => {
          if ((hideStatus && elm === "status") || elm === "period") {
            return <></>;
          }
          return (
            <Badge
              variant="secondary"
              className="gap-3 pr-1 cursor-pointer"
              key={elm}
            >
              {filters[elm].description}
              <CircleX
                onClick={() => {
                  handleClearFilter(elm);
                }}
              />
            </Badge>
          );
        })}
        {Object.keys(filters).length > 2 ? (
          <Badge variant="secondary" className="gap-3 pr-1 cursor-pointer">
            Clear All
            <CircleX
              onClick={() => {
                clearAllFilters();
              }}
            />
          </Badge>
        ) : (
          <></>
        )}
      </div>
    </>
  );
}
